import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';

export default function Tab1({ total }) {
    const { t } = useTranslation();
    return (
        <div className="flex justify-between">
            <div className="flex space-x-2 items-center">
                <div className="text-xl font-bold">
                    {t('RA.ActivitiesRegistration')}
                </div>
                <Tooltip
                    placement="right"
                    overlayStyle={{ minWidth: '23%' }}
                    title={
                        <>
                            <div>{t('RA.TooltipTap1.title')}</div>
                            <ul className="list-outside">
                                <li className="list-disc">
                                    {t('RA.TooltipTap1.list1')}
                                </li>
                                <li className="list-disc">
                                    {t('RA.TooltipTap1.list2')}
                                </li>
                                <li className="list-disc">
                                    {t('RA.TooltipTap1.list3')}
                                </li>
                            </ul>
                        </>
                    }
                >
                    <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                        <ExclamationCircleOutlined />
                    </a>
                </Tooltip>
            </div>
            <div
                style={{ color: '#65707A' }}
                className="flex font-semibold items-center"
            >
                {t('TotalItems', { length: total })}
            </div>
        </div>
    );
}
